import { useModalStore } from "./modal-service";
import { cn } from "@reframe-mobile/lib/cn";
import {
  BottomSheet,
  BottomSheetContent,
  BottomSheetHeader,
  BottomSheetTitle,
  BottomSheetDescription,
  BottomSheetFooter,
} from "@reframe-mobile/components/ui/bottom-sheet";
import { Button } from "@reframe-mobile/components/ui/button";

export function ModalProvider() {
  const { modal, closeModal } = useModalStore();
  const { isOpen, type, options } = modal;

  const handleConfirm = () => {
    closeModal(true);
  };

  const handleCancel = () => {
    closeModal(false);
  };

  const isDestructive = type === "destructive";
  const isAlert = type === "alert";

  return (
    <BottomSheet open={isOpen} onOpenChange={(open) => !open && handleCancel()}>
      <BottomSheetContent>
        <BottomSheetHeader>
          {options.title && (
            <BottomSheetTitle>{options.title}</BottomSheetTitle>
          )}
          <BottomSheetDescription
            className={cn(!options.title && "text-foreground text-base")}
          >
            {options.message}
          </BottomSheetDescription>
        </BottomSheetHeader>
        <BottomSheetFooter>
          {!isAlert && (
            <Button variant="outline" className="w-full" onClick={handleCancel}>
              {options.cancelText ?? "취소"}
            </Button>
          )}
          <Button
            variant={isDestructive ? "destructive" : "default"}
            className="w-full"
            onClick={handleConfirm}
          >
            {options.confirmText ?? "확인"}
          </Button>
        </BottomSheetFooter>
      </BottomSheetContent>
    </BottomSheet>
  );
}
